import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AiFillHome, AiOutlineReload } from 'react-icons/ai';
import { enums } from '../../../utils';

const ReloadButton = () => {
  const navigate = useNavigate();
  return (
    <button
      className="bg-[#005AA4] text-white font-semibold py-2 px-4 rounded-full mt-6 flex items-center"
      onClick={() => navigate(0)}
    >
      <AiOutlineReload className="mr-1" />
      <span>Reload</span>
    </button>
  );
};

const HomeLink = () => {
  return (
    <Link to={enums.AppPaths.home}>
      <div className="bg-[#005AA4] text-white font-semibold py-2 px-4 rounded-full mt-6 flex items-center">
        <AiFillHome className="mr-1" />
        <span>Home</span>
      </div>
    </Link>
  );
};

const TasksHomeLink = () => {
  return (
    <Link to={enums.AppPaths.tasks}>
      <div className="bg-[#005AA4] text-white font-semibold py-2 px-4 rounded-full mt-6 flex items-center">
        <AiFillHome className="mr-1" />
        <span>Home</span>
      </div>
    </Link>
  );
};

export { ReloadButton, HomeLink, TasksHomeLink };
